import { dataISOLocal } from '../pedidos/precos'

// Sairam de ListaPedidos.tsx (23/09) porque o Historico da ficha usa os mesmos.

export function limitesDoMes(ano: number, mes: number): { de: string; ate: string } {
  // Dia 0 do mes seguinte e o TRUQUE padrao pra "ultimo dia deste mes" -- o
  // Date de JS aceita mes fora de 0..11 e rola o ano sozinho, o que tambem
  // resolve "mes anterior" em janeiro (mes = -1 vira dezembro do ano anterior).
  return { de: dataISOLocal(new Date(ano, mes, 1)), ate: dataISOLocal(new Date(ano, mes + 1, 0)) }
}

// dd/mm/aaaa direto do texto do `<input type="date">`, SEM passar por
// `new Date('aaaa-mm-dd')` -- essa forma parseia em UTC e pode voltar um dia
// no fuso dela (armadilha ja registrada neste projeto).
export function dataBRDoTexto(iso: string): string {
  const [ano, mes, dia] = iso.split('-')
  return `${dia}/${mes}/${ano}`
}

function dataLocal(iso: string): Date {
  const [a, m, d] = iso.split('-').map(Number)
  return new Date(a, m - 1, d)
}

// O periodo de mesmo tamanho imediatamente antes -- a comparacao dos cards do
// Historico. Mes inteiro compara com o mes anterior INTEIRO (31 x 30 dias).
export function periodoAnterior(de: string, ate: string): { de: string; ate: string } {
  const [ini, fim] = de <= ate ? [dataLocal(de), dataLocal(ate)] : [dataLocal(ate), dataLocal(de)]
  const ehMesInteiro =
    ini.getDate() === 1 &&
    fim.getMonth() === ini.getMonth() &&
    fim.getFullYear() === ini.getFullYear() &&
    new Date(fim.getFullYear(), fim.getMonth(), fim.getDate() + 1).getDate() === 1
  if (ehMesInteiro) return limitesDoMes(ini.getFullYear(), ini.getMonth() - 1)
  const dias = Math.round((fim.getTime() - ini.getTime()) / 86_400_000) + 1
  return {
    de: dataISOLocal(new Date(ini.getFullYear(), ini.getMonth(), ini.getDate() - dias)),
    ate: dataISOLocal(new Date(ini.getFullYear(), ini.getMonth(), ini.getDate() - 1)),
  }
}
